export interface TrelloLabel {
  id: string;
  name: string;
  color: string;
  idBoard: string;
  uses?: number;
}

export interface LabelSuggestion {
  priority: 'High' | 'Medium' | 'Low';
  existingLabels: string[];
  suggestedNewLabel?: string;
  confidence: number;
}

export interface TaskWithLabels {
  id: string;
  title: string;
  description: string;
  priority: string;
  labels: string[];
  assignee?: string;
  due_date?: string; // Add back due date field
  selected: boolean;
  aiSuggestions?: LabelSuggestion;
  listId?: string; // Add listId for individual list selection
}

export interface StandardPriorityLabel {
  name: string;
  color: string;
  priority: 'High' | 'Medium' | 'Low';
}

export const STANDARD_PRIORITY_LABELS: StandardPriorityLabel[] = [
  { name: "🔴 High Priority", color: "red", priority: "High" },
  { name: "🟡 Medium Priority", color: "yellow", priority: "Medium" },
  { name: "🟢 Low Priority", color: "green", priority: "Low" }
];

export interface LabelCreationRequest {
  name: string;
  color: string;
  boardId: string;
}

export interface LabelSelectionState {
  selectedLabels: string[];
  customLabels: LabelCreationRequest[];
  priorityLabel?: string;
} 